import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

//创建Vuex实例
const store = new Vuex.Store({
  state: {
    siteUrl: 'https://qrcode-test.giant.com.cn/#/',
    api: {//api链接
      opo_store_api: 'https://org-api-test.giant.com.cn',//激活码接口
      common: 'https://gateway-test.giant.com.cn/giantService/',//接口
      login_api: 'https://sso-test.giant.com.cn/xxl-sso-server/sso', //单点登录接口
      new_login_api: 'https://org-api-test.giant.com.cn', //组织中台单点登录

      //login_api: 'https://appapi.giantev.com.cn/restful', //登录接口
      restful: 'https://appapi-test.giantev.com.cn', //restful服务
      egiant_api: 'https://e-gw-test.giant.com.cn', //官方商城
      service_api: 'https://opo-test.giant.com.cn/maintain', //服务预约
      club_api: 'https://club-test.giant.com.cn',
      export_api: 'https://gateway-test.giant.com.cn/giantService',
      opo_api: 'https://opo-test.giant.com.cn/opo',
      qrcode_api: 'https://giantqrcode.kssina.com/giantQRcode',//qrcode
      giantservice: 'https://giantqrcode.kssina.com:8080/giantService',
      upload_api: 'https://appapi.giantev.com.cn/upload', //上传接口
      insure_api: 'https://insure-test.giant.com.cn/#/',//保险中台
      map_api: 'https://map-test.giant.com.cn/index.php', //骑游地图
      maintain_api: 'https://maintain-test.giant.com.cn',//服务预约

      giant_api: 'https://giant-test.giant.com.cn/index.php',
    },
    externalurl: {//外部链接
      e_url: 'https://e-test.giant.com.cn', //在线商城
      qrcode_url: 'https://qrcode-test.giant.com.cn',
      opo: 'https://opo-test.giant.com.cn',
      banner: 'https://opo-test.giant.com.cn/opo/index.php/api/get_app_banner_list',
      chat: 'https://chat-test.giant.com.cn',
      officialwebsite_usercenter: 'https://u_api-test.giant.com.cn/index.php',
      common_sso_jump: 'https://dlinesso-test.giant.com.cn/index.php/api/app_sso_login?token=',//单点登录智能跳转 &url=
      giant_url: 'https://u-api-test.giant.com.cn/index.php',
      maintain_url: 'https://maintain-test.giant.com.cn',//服务预约
    },

    DLINE_ENVIRONMENT: '测试环境',//
    SHOW_DOWNLOAD: true,

    loginUser: {},//登录用户信息

    currentUser: {}, //当前查询信息角色属性

    browser: (function (ua) {
      var a = new Object();
      var b = {
        //micromessenger: /micromessenger/.test(ua),
        msie: /msie/.test(ua) && !/opera/.test(ua),
        opera: /opera/.test(ua),
        safari: /webkit/.test(ua) && !/chrome/.test(ua),
        firefox: /firefox/.test(ua),
        edge: /edge/.test(ua),
        trident: /trident/.test(ua),
        chrome: /chrome/.test(ua)
      };
      var vMark = "";
      for (var i in b) {
        if (b[i]) { vMark = i; break; }//"safari" == i ? "version" : i;
      }
      b.version = vMark && RegExp("(?:" + vMark + ")[\\/: ]([\\d.]+)").test(ua) ? RegExp.$1 : "0";
      b.ie = b.msie;
      b.ie6 = b.msie && parseInt(b.version, 10) == 6;
      b.ie7 = b.msie && parseInt(b.version, 10) == 7;
      b.ie8 = b.msie && parseInt(b.version, 10) == 8;

      //if(vMark == "trident") vMark = "ie11";

      a.b = vMark;
      a.v = b.version;
      a.m = /mobile/i.test(ua);
      a.wx = /MicroMessenger/i.test(ua);
      a.wxminiprogram = /miniProgram/i.test(ua);
      a.giantapp = /giantapp/i.test(ua);
      a.giantevapp = /giantevapp/i.test(ua);
      a.giantopoapp = /giantopoapp/i.test(ua);
      a.ios = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua);
      a.huawei = /huawei/i.test(ua);
      a.honor = /honor/i.test(ua);

      return a;
    })(window.navigator.userAgent.toLowerCase()),

    //电动车专属自定义页面编号
    giantEvIndexId: 27,

    // 属性切换
    type: 0

  },
  getters: {//相当于计算属性

  },
  mutations: {
    // 属性切换
    type(state, data) {
      state.type = data;
    },
    //逻辑处理，同步
    updateState(state, data) {//通用修改值
      state[data.label] = data.data;
    },
    changeApi(state, n) {//改变api链接
      if (n) {
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            state.api[key] = n[key]
          }
        }
      }
    },
    changeExternalurl(state, n) {//改变外部链接
      if (n) {
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            state.externalurl[key] = n[key]
          }
        }
      }
    },
    changeEnvironment(state, n) {//正式环境撤掉“测试”标志
      state.DLINE_ENVIRONMENT = n;
    },

    updateLoginUser(state, data) {//修改登录用户数据
      state.loginUser = data;
    },

  },
  actions: {//类似 mothods，异步

  }
});

//正式环境
if (window.location.host == 'data-yu.giant.com.cn') {
  store.commit('changeApi', {
    //common: 'https://e-gw-yu.giant.com.cn/index.php/',
  });
  store.commit('changeExternalurl', {
    opo: 'https://opo.giant.com.cn',
    banner: 'https://opo.giant.com.cn/opo/index.php/api/get_app_banner_list',
    chat: 'https://chat.giant.com.cn',
  });
  store.commit('changeEnvironment', '预发环境');//
  store.commit('updateState', {
    label: 'siteUrl',
    data: 'https://data-yu.giant.com.cn',
  });
} else if (window.location.host == 'qrcode.giant.com.cn') {//正式环境
  store.commit('changeApi', {
    opo_store_api: 'https://org-api.giant.com.cn',//激活码接口
    common: 'https://gateway.giant.com.cn/giantService/',
    login_api: 'https://sso.giant.com.cn/xxl-sso-server/sso', //单点登录接口
    new_login_api: 'https://org-api.giant.com.cn', //组织中台单点登录
    egiant_api: 'https://e-gw.giant.com.cn',
    restful: 'https://appapi.giantev.com.cn/', //restful服务
    service_api: 'https://opo.giant.com.cn/maintain', //服务预约
    club_api: 'https://club.giant.com.cn',
    export_api: 'https://gateway.giant.com.cn/giantService',
    opo_api: 'https://opo.giant.com.cn/opo',
    qrcode_api: 'https://qrcode.giant.com.cn',
    giantservice: 'http://service.giant.com.cn/giantService',
    insure_api: 'https://insure.giant.com.cn/#/',//保险中台
    map_api: 'https://map.giant.com.cn/index.php', //骑游地图
    maintain_api: 'https://maintain.giant.com.cn',//服务预约
    giant_api: 'https://www.giant.com.cn/index.php',
  });
  store.commit('changeExternalurl', {
    e_url: 'https://e.giant.com.cn', //在线商城
    opo: 'https://opo.giant.com.cn',
    banner: 'https://opo.giant.com.cn/opo/index.php/api/get_app_banner_list',
    chat: 'https://chat.giant.com.cn',
    officialwebsite_usercenter: 'https://u-api.giant.com.cn/index.php',
    common_sso_jump: 'https://dlinesso.giant.com.cn/index.php/api/app_sso_login?token=',
    giant_url: 'https://u-api.giant.com.cn/index.php',
    qrcode_url: 'https://qrcode.giant.com.cn/web',
    // qrcode_url: 'https://qrcode.giant.com.cn',
    e_url: 'https://e.giant.com.cn', //在线商城
    maintain_url: 'https://maintain.giant.com.cn',//服务预约
  });
  store.commit('changeEnvironment', false);//正式环境
  store.commit('updateState', {
    label: 'siteUrl',
    data: 'https://qrcode.giant.com.cn/web/#/',
    // data: 'https://qrcode.giant.com.cn/',
  });
} else if (window.location.host == 'qrcode-yu.giant.com.cn') {//正式环境
  store.commit('changeApi', {
    opo_store_api: 'https://org-api.giant.com.cn',//激活码接口
    common: 'https://gateway.giant.com.cn/giantService/',
    login_api: 'https://sso.giant.com.cn/xxl-sso-server/sso', //单点登录接口
    new_login_api: 'https://org-api.giant.com.cn', //组织中台单点登录
    egiant_api: 'https://e-gw.giant.com.cn',
    restful: 'https://appapi.giantev.com.cn/', //restful服务
    service_api: 'https://opo.giant.com.cn/maintain', //服务预约
    club_api: 'https://club.giant.com.cn',
    export_api: 'https://gateway.giant.com.cn/giantService',
    opo_api: 'https://opo.giant.com.cn/opo',
    qrcode_api: 'https://qrcode.giant.com.cn',
    giantservice: 'http://service.giant.com.cn/giantService',
    insure_api: 'https://insure.giant.com.cn/#/',//保险中台
    map_api: 'https://map.giant.com.cn/index.php', //骑游地图
    maintain_api: 'https://maintain.giant.com.cn',//服务预约
    giant_api: 'https://www.giant.com.cn/index.php',
  });
  store.commit('changeExternalurl', {
    e_url: 'https://e.giant.com.cn', //在线商城
    opo: 'https://opo.giant.com.cn',
    banner: 'https://opo.giant.com.cn/opo/index.php/api/get_app_banner_list',
    chat: 'https://chat.giant.com.cn',
    officialwebsite_usercenter: 'https://u-api.giant.com.cn/index.php',
    common_sso_jump: 'https://dlinesso.giant.com.cn/index.php/api/app_sso_login?token=',
    giant_url: 'https://u-api.giant.com.cn/index.php',
    qrcode_url: 'https://qrcode.giant.com.cn/web',
    // qrcode_url: 'https://qrcode.giant.com.cn',
    e_url: 'https://e.giant.com.cn', //在线商城
    maintain_url: 'https://maintain.giant.com.cn',//服务预约
  });
  store.commit('changeEnvironment', false);//正式环境
  store.commit('updateState', {
    label: 'siteUrl',
    data: 'https://qrcode-yu.giant.com.cn/web/#/',
    // data: 'https://qrcode.giant.com.cn/',
  });
}



//导出store
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js